module.exports = require('../math/sum');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/collection/sum.js
 ** module id = 145
 ** module chunks = 0
 **/